module.exports = __webpack_public_path__ + "img/location.ee9ee6f9.svg";